import { OdysseyOffcanvas, OffcanvasSize } from '@digiwall/core';
import { Injectable, Injector } from '@angular/core';
import { DepositInvoiceCreationComponent } from '../deposit-invoice-creation/deposit-invoice-creation.component';
import {
  CustomerInvoiceService,
  CustomerSalesPurchaseDto,
} from '@digiwall/goliath-documents/proxy';
import { ActivatedRoute } from '@angular/router';
import { first } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DepositInvoiceService {
  constructor(
    private canvaService: OdysseyOffcanvas,
    private injector: Injector,
    private customerInvoiceService: CustomerInvoiceService,
  ) {}

  public createDepositInvoice(
    salesPurchase: CustomerSalesPurchaseDto,
    languageCode: string,
    route: ActivatedRoute,
  ) {
    if (salesPurchase.invoiceTermId == null) {
      this.openDepositInvoiceCreationCanva(salesPurchase, languageCode, route);
    } else {
      this.customerInvoiceService
        .canCreateFromsalesPurchase(salesPurchase.id)
        .pipe(first())
        .subscribe(() => this.openDepositInvoiceCreationCanva(salesPurchase, languageCode, route));
    }
  }

  private openDepositInvoiceCreationCanva(
    salesPurchase: CustomerSalesPurchaseDto,
    languageCode: string,
    route: ActivatedRoute,
  ) {
    const { componentInstance } = this.canvaService.open(
      DepositInvoiceCreationComponent,
      this.injector,
      {
        offcanvasPanelClass: OffcanvasSize.Small,
      },
    );

    const depositInvoiceCreationComponent = componentInstance as DepositInvoiceCreationComponent;
    depositInvoiceCreationComponent.salesPurchase.set(salesPurchase);
    depositInvoiceCreationComponent.languageCode.set(languageCode);
    depositInvoiceCreationComponent.route.set(route);
  }
}
